import api from 'api';

const PATH = '/Relatorio';

const GET_RELATORIO_SOLICITACOES = async (filtros) => {
  const { data } = await api.post(`${PATH}/get-relatorio-solicitacoes`, {
    params: filtros,
  });
  return data;
};

const VALIDA_PERMISSAO_RELATORIO_DASH = async () => {
  const { data } = await api.get(`${PATH}/valida-permissao-relatorio-dash`);
  return data;
};

// eslint-disable-next-line import/prefer-default-export
export { GET_RELATORIO_SOLICITACOES, VALIDA_PERMISSAO_RELATORIO_DASH };
